import { useMemo } from 'react';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import type {
	SupporterVoicesVideoFirstExperiment,
	SupporterVoicesVideoFirstExperimentVariation,
} from '#src/app/pages/actions/pageContext';

/**
 * Exposes the resolved `supporter_voices_video_first` GrowthBook assignment from the page data.
 *
 * There is no app-level eligibility gate here (unlike `usePsfContactDecisionMakerExperiment`):
 * logged-in/mobile targeting is owned by the GrowthBook dashboard, and petition-level relevance is
 * handled in the render tree via `useDisableVideoCreation`. This hook is a plain passthrough so the
 * variant screens (CHANGE-97687/97688) can branch on `variation` and exposure can fire off the raw
 * `experiment`.
 */
export function useSupporterVoicesVideoFirstExperiment(): UseSupporterVoicesVideoFirstExperimentResult {
	const {
		data: { supporterVoicesVideoFirstExperiment },
	} = usePetitionActionsPageData();

	return useMemo(
		() => ({
			experiment: supporterVoicesVideoFirstExperiment,
			variation: supporterVoicesVideoFirstExperiment.variation,
		}),
		[supporterVoicesVideoFirstExperiment],
	);
}

type UseSupporterVoicesVideoFirstExperimentResult = Readonly<{
	/** The raw resolved GrowthBook experiment, for exposure tracking. */
	experiment: SupporterVoicesVideoFirstExperiment;
	variation: SupporterVoicesVideoFirstExperimentVariation;
}>;
